import TabView from './TabView';

export default TabView;
